<template>
    <div class="d-flex justify-content-between">
        <QuestionWeight :template="template" type="trueOrFalse"/>
        <span @click="clearHandler" class="reset-data-btn">Reset All</span>
    </div>

    <div :class="lightMood ? 'q-containerCopy' : 'q-container'">
        <div v-for="(q, idx) in template?.questions?.trueOrFalse?.questions"
             :key="idx"
             class="q-body d-flex  flex-column justify-content-start">
            <div class="d-flex gap-3">
                <div class="d-flex flex-column w-75 position-relative">
                    <QuestionComponent :id="'trueFalse-q'+idx" :template="template" type="trueOrFalse" :index="idx"
                                       :validationCB="trueOrFalseQuestionsValidation"/>
                </div>

                <div class="d-flex flex-column  justify-content-end align-items-start">
                    <div class="d-flex flex-column gap-3 justify-content-end align-items-start">
                        <div v-for="(a,index) in q.answers" class="d-flex gap-3">
                            <input @click="checkHandler($event, idx, index)" :id="idx+'-'+index" type="radio"
                                   :name="'trueFalse-'+idx"
                                   :value="true" v-model="a.is_correct" class="form-check-input"/>
                            <label :for="idx+'-'+index" class="form-check-label">{{a.value}}</label>
                        </div>
                    </div>

                </div>

                <div class="align-self-end"
                     v-if="(template.questions.trueOrFalse.questions.length - 1) === idx">
                        <span class="add-question align-self-end"
                              @click="addQuestionHandler($event, 'trueOrFalse')">+</span>
                </div>
            </div>

            <div class="d-flex gap-3">
                <div class=" w-75">
                    <div class="err w-75" v-if="q.errors['question'].length > 0">
                        <div v-for="msg in q.errors['question']" class="text-danger">{{msg}}</div>
                    </div>
                </div>
                <div>
                    <div class="err" v-if="q.errors['answers'].length > 0">
                        <div v-for="msg in q.errors['answers']" class="text-danger">{{msg}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <ConfirmationModal v-if="confirmFlag" :message="confirmMsg" confirmBtn="Yes" cancleBtn="No"
                       @close-modal="confirmModalHandler($event)"/>
    <span v-if="lightMood"></span>
</template>


<script>
    import {defineAsyncComponent, toRef, ref, computed, onMounted} from "vue";
    import QuestionWeight from "../../components/QuestionWeight";
    import QuestionComponent from "../../components/templateComponents/questionComponent";

    const ConfirmationModal = defineAsyncComponent(() =>
        import ('../../components/ConfirmationModal')
    );
    import increaseTemplateQuestions from "../../../helpers/increaseTemplateQuestionsCounter";
    import decreaseTemplateQuestions from "../../../helpers/decreaseTemplateQuestionsCounter";
    import qustionValidation from "../../../validation/qustionValidation";
    import {useStore} from "vuex";

    export default {
        name: 'app',

        props: {
            template: Object
        },
        components: {QuestionWeight, QuestionComponent, ConfirmationModal},

        setup(props, context) {
            const store = useStore();
            const confirmFlag = ref(false);
            const confirmMsg = ref('');
            const lightMood = computed({
                get() {
                    return store.state.settings.isLightMood;
                },
            });

            // onMounted(async () => {
            //     console.log(lightMood.value);
            // });

            const template = toRef(props, 'template');

            const checkHandler = (e, qIdex, aIdx) => {
                let errors = null;
                let element = template.value.questions.trueOrFalse.questions[qIdex];
                template.value.questions.trueOrFalse.questions[qIdex].errors['answers'] = [];


                template.value.questions.trueOrFalse.questions[qIdex].answers.forEach((answer, idx) => {
                    if (idx !== aIdx) {
                        answer.is_correct = false;
                    } else {
                        answer.is_correct = true;
                    }
                });

                errors = trueOrFalseQuestionsValidation(element);
                if (!errors)
                    increaseTemplateQuestions(template, 'trueOrFalse');
                else
                    decreaseTemplateQuestions(template, 'trueOrFalse');


            };


            const addQuestionHandler = (e, type) => {

                let length = template.value.questions[type].questions.length;
                let lastElement = template.value.questions[type].questions[length - 1];
                let isErrors = false;
                let question = null;

                isErrors = trueOrFalseQuestionsValidation(lastElement);

                question = {
                    question: '',
                    answers: [
                        {
                            value: 'True',
                            is_correct: false
                        },
                        {
                            value: 'False',
                            is_correct: false
                        }
                    ],
                    isDelete: true,
                    errors: {
                        question: [],
                        answers: []
                    }
                };

                if (!isErrors) {
                    addNewQuestionData(question, type)
                }
            };


            const confirmModalHandler = (e) => {
                confirmFlag.value = false;
                if (e) {
                    template.value.questions['trueOrFalse'].questions = [{
                        question: '',
                        answers: [
                            {
                                value: 'True',
                                is_correct: false
                            },
                            {
                                value: 'False',
                                is_correct: false
                            }
                        ],
                        isDelete: true,
                        errors: {
                            question: [],
                            answers: []
                        }
                    }];
                    if (template.value.questions['trueOrFalse'].counter > 0) {
                        template.value.questions['trueOrFalse'].counter = 0;
                        template.value.questionsCount -= 1;
                    }

                    template.value.questions['trueOrFalse'].isError = false;
                }
            };

            const clearHandler = () => {
                template.value.questions['trueOrFalse'].weight = null;
                template.value.questions['trueOrFalse']['errors']['weight']['isError'] = false;
                template.value.questions['trueOrFalse']['errors']['weight']['message'] = '';

                if (template.value.questions['trueOrFalse'].counter > 0 || template.value.questions['trueOrFalse'].isError) {
                    confirmFlag.value = true;
                    confirmMsg.value = 'Are you sure you want to reset data?';
                }
            };

            const deleteQuestionHandler = (idx, type) => {
                let errors = null;

                console.log({idx})
                let element = template.value.questions.trueOrFalse.questions[idx - 1];

                template.value.questions[type].questions.splice(idx, 1);

                errors = trueOrFalseQuestionsValidation(element);
                // if (!errors)
                //     decreaseTemplateQuestions(template, 'trueOrFalse');
            };

            const trueOrFalseQuestionsValidation = (element) => {

                if (process.env.VUE_ENV === 'development')
                console.log({element})
                let BreakException = {};

                let isErrors = {
                    question: false,
                    answers: false,
                };

                if (template.value.questions['trueOrFalse'].weight === null){
                    template.value.questions['trueOrFalse']['errors']['weight']['isError'] = true
                    template.value.questions['trueOrFalse']['errors']['weight']['message'] = '*Required'
                }

                isErrors.question = qustionValidation(element);

                try {
                    element.answers.forEach((ans) => {
                        if (ans.is_correct === true) {
                            element.errors['answers'] = [];
                            isErrors.answers = false;
                            throw BreakException;
                        } else {
                            element.errors['answers'] = ['*Required'];
                            isErrors.answers = true;
                        }
                    });
                } catch (e) {
                    if (e !== BreakException) throw e;
                }
                isErrors = isErrors.question || isErrors.answers;

                template.value.questions['trueOrFalse'].isError = isErrors;
                return isErrors;
            };

            const addNewQuestionData = (question, type) => {
                template.value.questions[type].questions.push(
                    question
                )
            };

            const checkErrors = (idx) => {
                let retVale = true;
                let errors = template.value.questions.trueOrFalse.questions[idx].errors;
                let weightError = template.value.questions.trueOrFalse.errors.weight;
                if (errors.question.length === 0 && errors.answers.length === 0 && !weightError) {
                    retVale = false;
                }
                return retVale;
            };

            return {
                template,
                confirmMsg,
                confirmFlag,
                lightMood: computed(() => store.state.settings.isLightMood),
                checkHandler,
                clearHandler,
                addQuestionHandler,
                deleteQuestionHandler,
                trueOrFalseQuestionsValidation,
                addNewQuestionData,
                checkErrors,
                confirmModalHandler,
                increaseTemplateQuestions,
                decreaseTemplateQuestions
            }
        }
    }

</script>

<style scoped>
    .q-body{
        height: 130px;
    }

    .add-question {
        font-size: 18px;
        font-weight: 500;
        cursor: pointer;
        color: #e65c00;
        border: 1px solid;
        border-radius: 50%;
        width: 25px;
        height: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
    }

    .add-question:hover {
        background-color: #e65c00;
        color: #032a3a;
    }

    .q-container {
        overflow-y: auto;
        padding: 20px;
        margin-top: 12px;
        background-color: #032A3A;
        border-radius: 20px;
        height: 92%;
    }
    .q-containerCopy {
        overflow-y: auto;
        padding: 20px;
        margin-top: 12px;
        /*background-color: #032A3A;*/
        border-radius: 20px;
        height: 92%;
    }

    .t-f-q-body {
        height: 120px;
    }

    .q-input {
        background-color: transparent !important;
        border: 1px solid #39525C;
        border-radius: 4px;
        height: 65px;
        color: var(--main-color);
        padding: 10px;
    }

    .q-input:focus,
    .q-input:focus-visible {
        outline: 0;
        color: var(--main-color);
    }

    .form-check-input {
        border: 1px solid #e95626 !important;;
        background-color: transparent !important;
    }

    .form-check-input:checked {
        background-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e") !important;
        border: 2px solid var(--border-color-data-table) !important;;
        background-color: #e95626 !important;
        box-shadow: 0 0 0 1px #e95626 !important;
    }

    .add-question {
        cursor: pointer;
        color: #e65c00;
    }

    .m-c-answer-container > input[type=text],
    .m-c-answer-container > input[type=text]:focus,
    .m-c-answer-container > input[type=text]:focus-visible {
        border: 0;
        color: #FFF;
        background-color: transparent;
        outline: 0;
    }
</style>